import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";

class CancelOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remarks: "",
      isLoading: false,
    };
  }

  handleChange = (e) => {
    this.setState({ remarks: e.target.value });
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    const isSuccess = await this.props.onSubmit(this.state.remarks);
    if (isSuccess) {
      this.props.onClose();
    }
    this.setState({ isLoading: false });
  }

  render() {
    const { remarks, isLoading } = this.state;
    const { title = 'Cancel Order', cancelSelectedOrder = {} } = this.props;
    return <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {isLoading && <CustomSpinner></CustomSpinner>}

        <Row className="m-0">
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <p><b>Dealer Name:</b> {cancelSelectedOrder.owner_name} ({cancelSelectedOrder.code})</p>
            <p><b>Group Order ID:</b> {cancelSelectedOrder.order_id}</p>
            <p><b>Order ID:</b> {cancelSelectedOrder.id}</p>
            <p><b>Order Date:</b> {cancelSelectedOrder.created_at}</p>
            <p><b>Product Name:</b> {cancelSelectedOrder.item_name}</p>
            <p><b>Product ID:</b> {cancelSelectedOrder.order_item_id}</p>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <Form>
              <FormGroup>
                <Label for="remarks"><b>Remarks</b></Label>
                <Input type="textarea" rows="3" name="remarks" id="remarks" value={remarks} onChange={this.handleChange} />
              </FormGroup>
            </Form>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <span className="common-note">
              <b>Note</b>: If you cancel this item, <b>only this product will be cancelled</b>

            </span>
          </Col>
          <Col className="text-align-right mt-4">
            <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.props.onClose()} style={{ width: '86px' }}>
              Close</Button> &nbsp;
            <Button
              type="button"
              className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
              color="warning"
              style={{ cursor: 'pointer', width: '86px' }}
              disabled={remarks.trim() === ""}
              onClick={() => this.handleSubmit()}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </ModalBody>

    </Modal>;
  }
}

export default CancelOrder;